module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_bell-2c7239b0fcf7bd5ce8f46e7ade1f26c6.svg";